import script from "./asset_view_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./asset_view_btn.vue?vue&type=script&setup=true&lang=js"

import "./asset_view_btn.vue?vue&type=style&index=0&id=73d71e92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d71e92"]])

export default __exports__